import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { addCommas, digitsEnToFa } from '@persian-tools/persian-tools';
import { OrderTarefeOptions } from 'src/app/shared';
import { PrintSizes } from 'src/app/core';

@Component({
  selector: 'app-tarefe',
  templateUrl: './tarefe.component.html',
  styleUrls: ['./tarefe.component.scss'],
})
export class TarefeComponent implements OnInit {
  @Input('selectedSize') selectedSize: PrintSizes = PrintSizes.A4;
  @Input('options') options!: OrderTarefeOptions;

  @Output('tarefeSelect') tfEvent = new EventEmitter();
  @Output('selectedSizeChange') selectedSizeChange =
    new EventEmitter<PrintSizes>();

  @Input('toggle') toggle!: boolean;
  @Output('toggleChange') toggleChange = new EventEmitter<boolean>();

  public printSizesEnum = PrintSizes;

  ngOnInit(): void {}
  constructor() {}

  getPrice(pointer: string): string {
    try {
      const pointerPaths = pointer.split('.');

      let opt: any = this.options[this.selectedSize];
      let result: any = undefined;

      for (let path of pointerPaths) {
        if (!result) {
          result = opt[path];
        } else {
          result = result[path];
        }
      }

      // return this.toPersianChars(result);
      return result;
    } catch (e) {
      console.error(e);
      // return this.toPersianChars('0');
      return '0';
    }
  }

  toPersianChars(value: string): string {
    return digitsEnToFa(addCommas(value));
  }

  selectSize(size: PrintSizes) {
    this.selectedSize = size;
    this.selectedSizeChange.emit(size);
  }

  public toggleTarefe() {
    this.toggle = !this.toggle;
    this.toggleChange.emit(this.toggle);
  }
}
